var _a;
/**
 * List of all the networks supported by the Uniswap Interface
 */
export var SupportedChainId;
(function (SupportedChainId) {
    SupportedChainId[SupportedChainId["MAINNET"] = 1] = "MAINNET";
    SupportedChainId[SupportedChainId["ROPSTEN"] = 3] = "ROPSTEN";
    SupportedChainId[SupportedChainId["RINKEBY"] = 4] = "RINKEBY";
    SupportedChainId[SupportedChainId["GOERLI"] = 5] = "GOERLI";
    SupportedChainId[SupportedChainId["KOVAN"] = 42] = "KOVAN";
    SupportedChainId[SupportedChainId["ARBITRUM_ONE"] = 42161] = "ARBITRUM_ONE";
    SupportedChainId[SupportedChainId["ARBITRUM_RINKEBY"] = 421611] = "ARBITRUM_RINKEBY";
    SupportedChainId[SupportedChainId["ARBITRUM_GOERLI"] = 421613] = "ARBITRUM_GOERLI";
    SupportedChainId[SupportedChainId["OPTIMISM"] = 10] = "OPTIMISM";
    SupportedChainId[SupportedChainId["OPTIMISTIC_KOVAN"] = 69] = "OPTIMISTIC_KOVAN";
    SupportedChainId[SupportedChainId["POLYGON"] = 137] = "POLYGON";
    SupportedChainId[SupportedChainId["POLYGON_MUMBAI"] = 80001] = "POLYGON_MUMBAI";
})(SupportedChainId || (SupportedChainId = {}));
export var CHAIN_IDS_TO_NAMES = (_a = {},
    _a[SupportedChainId.MAINNET] = 'mainnet',
    _a[SupportedChainId.ROPSTEN] = 'ropsten',
    _a[SupportedChainId.RINKEBY] = 'rinkeby',
    _a[SupportedChainId.GOERLI] = 'goerli',
    _a[SupportedChainId.KOVAN] = 'kovan',
    _a[SupportedChainId.POLYGON] = 'polygon',
    _a[SupportedChainId.POLYGON_MUMBAI] = 'polygon_mumbai',
    _a[SupportedChainId.ARBITRUM_ONE] = 'arbitrum',
    _a[SupportedChainId.ARBITRUM_RINKEBY] = 'arbitrum_rinkeby',
    _a[SupportedChainId.ARBITRUM_GOERLI] = 'arbitrum_goerli',
    _a[SupportedChainId.OPTIMISM] = 'optimism',
    _a[SupportedChainId.OPTIMISTIC_KOVAN] = 'optimistic_kovan',
    _a);
/**
 * Array of all the supported chain IDs
 */
export var ALL_SUPPORTED_CHAIN_IDS = Object.values(SupportedChainId).filter(function (id) { return typeof id === 'number'; });
export var SUPPORTED_GAS_ESTIMATE_CHAIN_IDS = [
    SupportedChainId.MAINNET,
    SupportedChainId.POLYGON,
    SupportedChainId.OPTIMISM,
    SupportedChainId.ARBITRUM_ONE,
];
/**
 * All the chain IDs that are running the Ethereum protocol.
 */
export var L1_CHAIN_IDS = [
    SupportedChainId.MAINNET,
    SupportedChainId.ROPSTEN,
    SupportedChainId.RINKEBY,
    SupportedChainId.GOERLI,
    SupportedChainId.KOVAN,
    SupportedChainId.POLYGON,
    SupportedChainId.POLYGON_MUMBAI,
];
/**
 * Controls some L2 specific behavior, e.g. slippage tolerance, special UI behavior.
 * The expectation is that all of these networks have immediate transaction confirmation.
 */
export var L2_CHAIN_IDS = [
    SupportedChainId.ARBITRUM_ONE,
    SupportedChainId.ARBITRUM_RINKEBY,
    SupportedChainId.ARBITRUM_GOERLI,
    SupportedChainId.OPTIMISM,
    SupportedChainId.OPTIMISTIC_KOVAN,
];
